import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from './Modal'
import { Button } from './Button'

interface GuestLimitModalProps {
    isOpen: boolean
    onClose: () => void
}

export const GuestLimitModal: React.FC<GuestLimitModalProps> = ({
    isOpen,
    onClose,
}) => {
    const navigate = useNavigate()

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Daily Limit Reached">
            <div className="space-y-6">
                <div className="text-center">
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100 mb-4">
                        <svg
                            className="h-6 w-6 text-yellow-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
                        You've reached your guest limit
                    </h3>
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        You've used your free message for today. Sign up for a free account to continue practicing and unlock more features!
                    </p>
                </div>

                <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3">
                    <Button
                        variant="primary"
                        className="w-full justify-center"
                        onClick={() => navigate('/auth')}
                    >
                        Create Free Account
                    </Button>
                    <Button
                        variant="outline"
                        className="w-full justify-center"
                        onClick={() => navigate('/')}
                    >
                        Back to Home
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
